import { render, staticRenderFns } from "./Vochers.vue?vue&type=template&id=8feebc64&scoped=true&"
import script from "./Vochers.vue?vue&type=script&lang=js&"
export * from "./Vochers.vue?vue&type=script&lang=js&"
import style0 from "./Vochers.vue?vue&type=style&index=0&id=8feebc64&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8feebc64",
  null
  
)

export default component.exports